<template>
    <defs v-if="gradient">
        <linearGradient
            :id="id"
            :x1="+(gradientDirection === 'left')"
            :y1="+(gradientDirection === 'top')"
            :x2="+(gradientDirection === 'right')"
            :y2="+(gradientDirection === 'bottom')"
        >
            <stop v-for="(color, index) in gradient.slice().reverse()" :key="index"
                :offset="index /len"
                :stop-color="color"
            ></stop>
        </linearGradient>
    </defs>
</template>

<script>
export default {
    name: 'vs-svg-line-gradient',
    props: ['gradient', 'gradientDirection', 'id'],
    computed: {
        len () {
            return this.gradient.length - 1 || 1
        }
    }
}
</script>

<style>

</style>
